/**
 * formatMatchDate — Converts a UTC match date string to the user's local time.
 *
 * The backend returns dates without timezone (e.g. "2026-06-11T19:00:00").
 * Appending "Z" forces the browser to treat it as UTC, then automatically
 * converts to the user's local timezone.
 *
 * Examples (match at 19:00 UTC):
 *   Kinshasa  UTC+2 → "Auj. 21:00"
 *   Paris     UTC+1 → "Auj. 20:00"
 *   New York  UTC-5 → "Auj. 14:00"
 */
export function formatMatchDate(dateStr) {
  if (!dateStr) return '';

  // If the string already has a timezone indicator, use it as-is
  const raw  = /[Z+]/.test(dateStr) ? dateStr : dateStr + 'Z';
  const date = new Date(raw);

  if (isNaN(date)) return dateStr; // fallback — return original string

  const today    = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  const isToday    = date.toDateString() === today.toDateString();
  const isTomorrow = date.toDateString() === tomorrow.toDateString();

  const time = date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

  if (isToday)    return `Auj. ${time}`;
  if (isTomorrow) return `Dem. ${time}`;

  return date.toLocaleDateString('fr-FR', {
    day:    '2-digit',
    month:  'short',
    year:   'numeric',
    hour:   '2-digit',
    minute: '2-digit',
  });
}
